import { BACKEND_BASE_URL } from "@/utils/globalConstants.js";
import { fetchAndLog } from "@/utils/fetchAndLogToBackend.js";
import {getRequest} from "@/services/utils";

export const baseUrl = BACKEND_BASE_URL;

export class Statistics {
  static filterRegionalModules(options) {
    let { to, from, regionId, limit, offset } = options;

    if (!limit) {
      limit = 10;
    }
    if (!offset) {
      offset = 0;
    }

    // const authToken = localStorage.getItem("authToken");
    // if (!authToken) {
    //   window.clientLogger("No auth token found");
    //   throw new Error("No auth token found");
    // }

    let url = `${baseUrl}/kartlegging/regions/${regionId}/moduleassignments/?limit=${limit}&offset=${offset}`;

    if (to && !from) {
      url = `${baseUrl}/kartlegging/regions/${regionId}/moduleassignments/?to=${to}&limit=${limit}&offset=${offset}`;
    }

    if (!to && from) {
      url = `${baseUrl}/kartlegging/regions/${regionId}/moduleassignments/?from=${from}&limit=${limit}&offset=${offset}`;
    }

    if (to && from) {
      url = `${baseUrl}/kartlegging/regions/${regionId}/moduleassignments/?from=${from}&to=${to}&limit=${limit}&offset=${offset}`;
    }

    const request = getRequest();

    return fetchAndLog(url, request);
  }

  static getRegionalStatistics(options) {
    const { regionId } = options;

    // const authToken = localStorage.getItem("authToken");
    // if (!authToken) {
    //   window.clientLogger("No auth token found");
    //   throw new Error("No auth token found");
    // }
      
      const request = getRequest();

    return fetchAndLog(`${baseUrl}/kartlegging/regions/${regionId}/statistics/`, request);
  }

  static getRegion( ) {
    // const {  } = options;

    // eslint-disable-next-line
    // const authToken = localStorage.getItem("authToken") || token;
    // if (!authToken) {
    //   window.clientLogger("No auth token found");
    //   throw new Error("No auth token found");
    // }
      
    const request = getRequest();   

    return fetchAndLog(`${baseUrl}/people/v1/me`, request);
  }

  static async getRegionalUserStatistics(options = {}) {
    const { regionId, candidateId } = options;

    // eslint-disable-next-line
    // const authToken = localStorage.getItem("authToken") || token;
    //
    // if (!authToken) {
    //   window.clientLogger("No auth token found");
    //   throw new Error("No auth token found");
    // }
    const request = getRequest();

    return fetchAndLog(`${baseUrl}/kartlegging/regions/${regionId}/statistics/${candidateId}`, request);
  }

  static getNationalStatistics(options = {}) {
    let { limit, offset, from, to, distinctUser } = options;

    // const authToken = localStorage.getItem("authToken");
    // if (!authToken) {
    //   window.clientLogger("No auth token found");
    //   throw new Error("No auth token found");
    // }

    if (!offset) {
      offset = 0;
    }

    if (!limit) {
      limit = 10;
    }

    if (!distinctUser) {
      distinctUser = false;
    }

    let url = `${baseUrl}/kartlegging/module-distribution/`;
    if (from && to) {
      url = `${baseUrl}/kartlegging/module-distribution/?from=${from}&to=${to}`;
    } else if (from && !to) {
      url = `${baseUrl}/kartlegging/module-distribution/?from=${from}`;
    } else if (!from && to) {
      url = `${baseUrl}/kartlegging/module-distribution/?to=${to}`;
    }

    const request = getRequest();

    return fetchAndLog(url, request);
  }
}


export class StatisticsUtils {
  static unpopulatedStatistics() {
    return unpopulated;
  }

  static mockStatistics() {
    return mocked;
  }

  static parseUserOrRegionStatistics(response) {
    // corresponds to the table to display and the names of what is returned from the db
    const parsed = structuredClone(unpopulated);

    let total_correct = 0;
    let total_incorrect = 0;

    response.answers.map((mod) => {
      parsed[mod.Modul.name][mod.Tema.name] = {
        correct_answers: mod.CA,
        incorrect_answers: mod.IA,
      };

      total_correct += mod.CA;
      total_incorrect += mod.IA;
    });

    parsed.total_correct = total_correct;
    parsed.total_incorrect = total_incorrect;

    return parsed;
  }
}


const unpopulated = {
  "Modul 1": {
    "Tall og algebra": { correct_answers: 0, incorrect_answers: 0 },
    "Måling og geometri": { correct_answers: 0, incorrect_answers: 0 },
    Økonomi: { correct_answers: 0, incorrect_answers: 0 },
    "Statistikk, kombinatorikk og sannsynlighet": {
      correct_answers: 0,
      incorrect_answers: 0,
    },
    Funksjoner: { correct_answers: 0, incorrect_answers: 0 },
  },
  "Modul 2": {
    "Tall og algebra": { correct_answers: 0, incorrect_answers: 0 },
    "Måling og geometri": { correct_answers: 0, incorrect_answers: 0 },
    Økonomi: { correct_answers: 0, incorrect_answers: 0 },
    "Statistikk, kombinatorikk og sannsynlighet": {
      correct_answers: 0,
      incorrect_answers: 0,
    },
    Funksjoner: { correct_answers: 0, incorrect_answers: 0 },
  },
  "Modul 3": {
    "Tall og algebra": { correct_answers: 0, incorrect_answers: 0 },
    "Måling og geometri": { correct_answers: 0, incorrect_answers: 6 },
    Økonomi: { correct_answers: 0, incorrect_answers: 0 },
    "Statistikk, kombinatorikk og sannsynlighet": {
      correct_answers: 0,
      incorrect_answers: 0,
    },
    Funksjoner: { correct_answers: 0, incorrect_answers: 0 },
  },
  "Modul 4": {
    "Tall og algebra": { correct_answers: 0, incorrect_answers: 0 },
    "Måling og geometri": { correct_answers: 0, incorrect_answers: 0 },
    Økonomi: { correct_answers: 0, incorrect_answers: 0 },
    "Statistikk, kombinatorikk og sannsynlighet": {
      correct_answers: 0,
      incorrect_answers: 0,
    },
    Funksjoner: { correct_answers: 0, incorrect_answers: 0 },
  },
  total_correct: 0,
  total_incorrect: 0,
};


const mocked = {
  "Modul 1": {
    "Tall og algebra": { correct_answers: 2, incorrect_answers: 1 },
    "Måling og geometri": { correct_answers: 3, incorrect_answers: 1 },
    Økonomi: { correct_answers: 1, incorrect_answers: 3 },
    "Statistikk, kombinatorikk og sannsynlighet": {
      correct_answers: 3,
      incorrect_answers: 1,
    },
    Funksjoner: { correct_answers: 0, incorrect_answers: 0 },
  },
  "Modul 2": {
    "Tall og algebra": { correct_answers: 1, incorrect_answers: 2 },
    "Måling og geometri": { correct_answers: 2, incorrect_answers: 0 },
    Økonomi: { correct_answers: 4, incorrect_answers: 0 },
    "Statistikk, kombinatorikk og sannsynlighet": {
      correct_answers: 5,
      incorrect_answers: 0,
    },
    Funksjoner: { correct_answers: 0, incorrect_answers: 0 },
  },
  "Modul 3": {
    "Tall og algebra": { correct_answers: 6, incorrect_answers: 0 },
    "Måling og geometri": { correct_answers: 0, incorrect_answers: 6 },
    Økonomi: { correct_answers: 3, incorrect_answers: 1 },
    "Statistikk, kombinatorikk og sannsynlighet": {
      correct_answers: 2,
      incorrect_answers: 3,
    },
    Funksjoner: { correct_answers: 0, incorrect_answers: 0 },
  },
  "Modul 4": {
    "Tall og algebra": { correct_answers: 0, incorrect_answers: 1 },
    "Måling og geometri": { correct_answers: 0, incorrect_answers: 1 },
    Økonomi: { correct_answers: 1, incorrect_answers: 1 },
    "Statistikk, kombinatorikk og sannsynlighet": {
      correct_answers: 0,
      incorrect_answers: 1,
    },
    Funksjoner: { correct_answers: 1, incorrect_answers: 1 },
  },
  total_correct: 32,
  total_incorrect: 22,
};